import { DataBean } from "../DataBean";

export class UBLPayment extends DataBean {



    public async getUBLPaymentCatalog(idUBLInvoice: any, issueDate: any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "java.util.List_getUBLPaymentCatalog_Number_java.util.Date", [idUBLInvoice, issueDate]);
    }

}